import { schema } from 'normalizr'

export const patientSchema = new schema.Entity('patients')
